import { ILocation } from '@rbi-ctg/frontend';
import { IDeliveryAddress } from 'generated/rbi-graphql';
import { IErrorModal } from 'hooks/use-error-modal';
import { UserDetails } from 'state/auth/hooks/types';
import { FormValidationState } from 'utils';
import { IPlaceAddress, IPlaceData } from 'utils/geolocation';

import { StoreLocatorSteps } from '../../pages/store-locator/types';

export interface ICompleteDeliveryOptions {
  coords: ILocation;
  selectedAddressComponents: IPlaceAddress;
  selectedShouldSaveAddress: boolean;
  selectedDeliveryInstructions: string;
  selectedPhoneNumber: string;
}

export interface IDeliveryAddressFormProps {
  instructions?: string;
  user?: UserDetails | null;
  getDetailsPlaceData: (id: string) => Promise<IPlaceData>;
  showDeliveryAddresses: boolean;
  setAddress: (address: SelectedDeliveryAddress) => void;
  currentStep: StoreLocatorSteps;
  setCurrentStep: (view: StoreLocatorSteps) => void;
  isLoading: boolean;
  editedAddress?: IDeliveryAddress | null;
  setEditedAddress?: (address: IDeliveryAddress) => void;
  skipSavedAddressClosedStore?: boolean;
}

export interface IPhoneAddressValidation {
  phoneNumber: FormValidationState;
  address: FormValidationState;
}

export enum ActionStatus {
  ERROR = 'ERROR',
  IDLE = 'IDLE',
  PENDING = 'PENDING',
  QUOTE_UNAVAILABLE = 'QUOTE_UNAVAILABLE',
  SUCCESS = 'SUCCESS',
  UPDATE = 'UPDATE',
  DELIVERY_ADDRESS = 'DELIVERY_ADDRESS',
  CONFIRM_SAVE_DELIVERY_ADDRESS = 'CONFIRM_SAVE_DELIVERY_ADDRESS',
  CONFIRM_SAVE_DELIVERY_ADDRESS_WITH_LOCATION = 'CONFIRM_SAVE_DELIVERY_ADDRESS_WITH_LOCATION',
  SAVE_DELIVERY_ADDRESS_OTHER_LOCATION = 'SAVE_DELIVERY_ADDRESS_OTHER_LOCATION',
  CONFIRM_DELETE_DELIVERY_ADDRESS = 'CONFIRM_DELETE_DELIVERY_ADDRESS',
  DELIVERY_CLOSED_AT_MOMENT = 'DELIVERY_CLOSED_AT_MOMENT',
  DELIVERY_PAUSED = 'DELIVERY_PAUSED',
}

export type SelectedDeliveryAddress = {
  address: IPlaceAddress;
  phoneNumber: string;
  deliveryInstructions?: string;
  placeId?: string;
  coordinates?: ILocation;
  shouldSaveAddress?: boolean;
};

export type AddressModalAction =
  | { type: ActionStatus.IDLE }
  | { type: ActionStatus.QUOTE_UNAVAILABLE }
  | { type: ActionStatus.SUCCESS }
  | { type: ActionStatus.ERROR; error: IErrorModal }
  | { type: ActionStatus.PENDING; address: SelectedDeliveryAddress }
  | { type: ActionStatus.DELIVERY_CLOSED_AT_MOMENT }
  | { type: ActionStatus.DELIVERY_PAUSED; error: IErrorModal };

export type DeliveryAddressModalAction =
  | { type: ActionStatus.DELIVERY_ADDRESS }
  | { type: ActionStatus.CONFIRM_SAVE_DELIVERY_ADDRESS }
  | { type: ActionStatus.CONFIRM_SAVE_DELIVERY_ADDRESS_WITH_LOCATION }
  | { type: ActionStatus.SAVE_DELIVERY_ADDRESS_OTHER_LOCATION }
  | { type: ActionStatus.CONFIRM_DELETE_DELIVERY_ADDRESS };
